import { Button, FormLabel, Input } from "@mui/material";
import { developAxios } from "../../axios.config";
import { Store } from "react-notifications-component";
import { useMutation, useQuery } from "react-query";
import React, { useEffect, useState } from "react";
import Select from "react-select";

interface IEditTemplate {
	_id: string;
	name: string;
}

const dashboardOptions = [
	{
		label: "Home",
		value: "Home",
	},
	{
		label: "Learning",
		value: "Learning",
	},
	{
		label: "Technical",
		value: "Technical",
	},
	{
		label: "Aptitude",
		value: "Aptitude",
	},
	{
		label: "Practise Test",
		value: "PractiseTest",
	},
	{
		label: "Project",
		value: "Project",
	},
	{
		label: "Company Preparation",
		value: "CompanyPreparation",
	},
	{
		label: "Company Training",
		value: "CompanyTraining",
	},
	{
		label: "Mock Interview",
		value: "MockInterview",
	},
];

const EditTemplate = ({
	_id: dashboardId,
	name: dashboardName,
}: IEditTemplate) => {
	const [name, setName] = useState<string>(dashboardName);
	const [selected, setSelected] = useState<
		ReadonlyArray<{
			value: string;
			label: string;
		}>
	>([]);

	const { data } = useQuery(
		["superadmin", "course", "dashboard-template", dashboardId],
		() =>
			developAxios(localStorage.getItem("token") || "").get<{
				data: {
					_id: string;
					name: string;
					sideNavBar: any;
				};
			}>(`/superadmin/course/dashboard-template/${dashboardId}`)
	);

	const { mutate } = useMutation(
		() => {
			const sideNavBar: { [item: string]: any } = {};

			selected.forEach((val) => {
				sideNavBar[val.value] = {};
			});
			return developAxios(localStorage.getItem("token") || "").post(
				`/superadmin/course/dashboard-template/${dashboardId}`,
				{ sideNavBar, name }
			);
		},
		{
			onSuccess: () => {
				notifyPopup("Updated successfuly", "success");
			},
			onError: (error: any) => {
				if (error.name === "AxiosError") {
					const error_message = error.response.data.message;
					notifyPopup(error_message, "danger");
				}
			},
		}
	);

	useEffect(() => {
		if (!data || !data.data) return;

		setName(data.data.data.name);
		const { sideNavBar } = data.data.data;

		setSelected(dashboardOptions.filter((val) => !!sideNavBar[val.value]));
	}, [data]);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		mutate();
	};

	function notifyPopup(backend_message: string, type: "success" | "danger") {
		Store.addNotification({
			title: type === "danger" ? "Error Occured" : "Success",
			message: backend_message,
			type: type,
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	}

	return (
		<form onSubmit={handleSubmit} className="space-y-4">
			<div className="flex gap-3 font-semibold">
				<span className="text-red-600">*</span>
				<span>- Required Fields</span>
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="name">
					Template Name
					<span className="text-red-600">*</span>
				</FormLabel>
				<Input
					id="name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					required
				/>
			</div>
			<div className="flex gap-4 items-center">
				<Select
					options={dashboardOptions}
					closeMenuOnSelect={false}
					isMulti={true}
					value={selected}
					onChange={(val) => setSelected(val)}
				/>
			</div>
			<Button variant="contained" type="submit">
				Update Template
			</Button>
		</form>
	);
};

export default EditTemplate;
